// import My from '@/view/my/Index.vue'
import { NativeTabNavigatoLayout } from '@/layout'
import My from '@/view/my/Index.vue'

const routes = [
  {
    path: '/nativeTab',
    component: NativeTabNavigatoLayout,
    children: [
      {
        path: 'my',
        name: 'my',
        // component: () => import('@/view/my/Index.vue'),
        component: My
      },
    ]
  }
  // {
  //   path: '/nativeTab/my',
  //   name: 'my',
  //   // component: () => import('@/view/news/Index.vue')
  //   component: My,
  // },
  // {
  //   path: '/my',
  //   name: 'my',
  //   component: () => import('@/view/my/Index.vue')
  // },
]

export default { routes }